import { Matrix4 } from 'three';

interface ISvgBounds {
    minX: number;
    minY: number;
    svgH: number;
    svgW: number;
}

interface ICardDimensions {
    cardD: number;
    cardH: number;
    cardW: number;
}

function svgBoundsToSceneMatrix(bounds: ISvgBounds, card: ICardDimensions): Matrix4 {
    const { minX, minY, svgH, svgW } = bounds;
    const { cardD, cardH, cardW } = card;

    const scaleX = cardW / svgW;
    const scaleY = -cardH / svgH;
    const scaleZ = cardD;

    const tx = -(minX + svgW / 2) * scaleX;
    const ty = (minY + svgH / 2) * (cardH / svgH);
    const tz = -cardD / 2;

    return new Matrix4().makeScale(scaleX, scaleY, scaleZ).setPosition(tx, ty, tz);
}

export { svgBoundsToSceneMatrix };
